import React from "react";

import { observer } from "mobx-react";
import { Form } from "react-bootstrap";

import { DOBIcon, GenderIcon, NationalityIcon } from "constants/Images";
import { BottomsheetDropdown, CustomCheckbox, DatepickerModal } from "components";
import { toJS } from "mobx";
import AuthStore from "modules/login/store/AuthStore";
import { LA_PR_FAMILY_PROFILE } from "constants/UserClicksConstant";

const AddProposerData = ({ employee, formController, updateValue }) => {

    let employeefieldData = employee[0]?.[1].fields

    return (
        <div className='px-3 px-xl-2 border-bottom mt-3 pb-3'>
            <div className='d-flex justify-content-between'>
                <p className='mt-1 mb-0 mr-1 font-size-lg-14 font-size-14 font-weight-medium font-weight-lg-light '>
                    <span className="text-secondary"> {` 1.`}</span> Proposer
                </p>
                {/* nationality in mobile view */}
                <div className='d-flex align-items-center justify-content-between d-lg-none'>
                    <div className='d-flex d-xl-none align-items-center  mb-1'>
                        <p className='font-size-14 font-size-md-12 font-weight-normal text-description-text-color ml-1 mb-0 ml-md-3 pr-1'>
                            {employeefieldData.nationality.label}

                        </p>
                    </div>

                    <div className='d-flex'>
                        <BottomsheetDropdown
                            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
                            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                            menuItemStyle='d-flex justify-content-between align-items-center'
                            selectedLabelKey='label'
                            bottomsheetTitle={employeefieldData?.nationality?.extra?.bottomSheetTitle}
                            defaultLabel={employeefieldData.nationality.label}
                            menuList={employeefieldData?.nationality?.extra?.optionList}
                            value={employeefieldData.nationality.value}
                            onSelect={(value) => updateValue(formController, employee[0]?.[0], 'nationality', value)}
                            showErrorMsg={employeefieldData.nationality.error != null}
                            disabled={false}
                        />
                    </div>
                </div>
                <div className="d-none d-lg-block">
                    <CustomCheckbox
                        shape='rounded'
                        title={employeefieldData.life_assured.label}
                        containerStyle='col-0 text-nowrap mb-0 pl-0 pr-1 align-items-center'
                        titleStyle='fw-medium font-size-14 pl-1 pr-2  details-title-text'
                        isChecked={employeefieldData.life_assured.value}
                        onChange={(value) => {
                            updateValue(formController, employee[0]?.[0], 'life_assured', value),
                            //! for save user clicks
                            AuthStore.saveUserClicks(LA_PR_FAMILY_PROFILE)
                        }}
                        mark='checkmark'
                        disabled={employeefieldData.life_assured.disabled}
                    />

                    <CustomCheckbox
                        shape='rounded'
                        title={employeefieldData.proposer.label}
                        containerStyle='col-0 text-nowrap mb-0 pl-0 pr-1 align-items-center'
                        titleStyle='fw-medium font-size-14 pl-1 pr-2 details-title-text '
                        isChecked={employeefieldData.proposer.value}
                        onChange={(value) => {
                            updateValue(formController, employee[0]?.[0], 'proposer', value),
                            //! for save user clicks
                            AuthStore.saveUserClicks(LA_PR_FAMILY_PROFILE)
                        }}
                        mark='checkmark'
                        disabled={employeefieldData.proposer.disabled}
                    />
                </div>
            </div>

            <hr className='w-100 border-secondary-opacity-50 my-2 d-lg-none' />

            <div className="d-block d-lg-none d-flex align-items-center justify-content-between mb-2">
                <CustomCheckbox
                    shape='rounded'
                    title={employeefieldData.life_assured.label}
                    containerStyle='col-0 text-nowrap mb-0 pl-0 pr-1 align-items-center'
                    titleStyle='fw-medium font-size-14 pl-1 pr-2  details-title-text'
                    isChecked={employeefieldData.life_assured.value}
                    onChange={(value) => {
                        updateValue(formController, employee[0]?.[0], 'life_assured', value),
                        //! for save user clicks
                        AuthStore.saveUserClicks(LA_PR_FAMILY_PROFILE)
                    }}
                    mark='checkmark'
                    disabled={employeefieldData.life_assured.disabled}
                />

                <CustomCheckbox
                    shape='rounded'
                    title={employeefieldData.proposer.label}
                    containerStyle='col-0 text-nowrap mb-0 pl-0 pr-1 align-items-center'
                    titleStyle='fw-medium font-size-14 pl-1 pr-2 details-title-text '
                    isChecked={employeefieldData.proposer.value}
                    onChange={(value) => {
                        updateValue(formController, employee[0]?.[0], 'proposer', value),
                        //! for save user clicks
                        AuthStore.saveUserClicks(LA_PR_FAMILY_PROFILE)
                    }}
                    mark='checkmark'
                    disabled={employeefieldData.proposer.disabled}
                />
            </div>


            <div className='mt-1 d-flex flex-wrap'>
                <div className='family-member-name-section d-flex flex-lg-row justify-content-between'>
                    {/* <div className="mr-lg-2 mb-0 mb-lg-0 pr-2 pr-lg-0">
                        <div className="d-flex align-middle">
                             <div className="w-100">
                                <BottomsheetDropdown
                                    dropdownStyle='font-size-lg-12 font-size-14 font-weight-light salutation-dropdown'
                                    menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                                    menuItemStyle='d-flex justify-content-between align-items-center'
                                    selectedLabelKey='label'
                                    bottomsheetTitle={employeefieldData.salutation.extra.bottomSheetTitle}
                                    defaultLabel=''
                                    menuList={employeefieldData.salutation.extra.optionList}
                                    onSelect={(value) => updateValue(formController, employee[0]?.[0], "salutation", value)}
                                    value={employeefieldData.salutation.value}
                                    showErrorMsg={employeefieldData.salutation.error !== null}
                                    errorMsg={employeefieldData.salutation.error}
                                    disabled={true}
                                />
                            </div> 
                        </div>
                    </div> */}
                    <div className="mb-0 mb-lg-0  pr-md-0 w-100 mr-md-2"  >
                        <Form.Control
                            placeholder={"Company Name"}
                            value={employeefieldData.first_name.value}
                            onChange={(event) => updateValue(formController, employee[0]?.[0], "first_name", event.target.value)}
                            disabled={employeefieldData.first_name.disabled}
                            className={`${employeefieldData.first_name.error !== null ? "validation-border font-weight-light font-size-12" : "font-size-12 font-weight-light "} calculator-monthly-income-field`}
                            style={{ border: "1px solid #797979" }}

                        />
                        {employeefieldData.first_name.error && (
                            <p className='text-danger mb-0 font-weight-light font-size-12 align-items-start d-flex'>
                                {employeefieldData.first_name.error}
                            </p>
                        )}
                    </div>




                    {/* gender in table and desktop view */}
                    <div className='other-details-section-gender flex-xs-column flex-lg-row  d-none d-lg-flex'>
                        <img src={GenderIcon} alt='calender-icon' className='add-family-member-card-top-img d-inline d-xl-none mr-1 mb-sm-1 mb-lg-0' />

                        <BottomsheetDropdown
                            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light gender-dropdown'
                            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                            menuItemStyle='d-flex justify-content-between align-items-center'
                            selectedLabelKey='label'
                            bottomsheetTitle={employeefieldData.gender.extra.bottomSheetTitle}
                            defaultLabel='Select'
                            disabled={true}
                            menuList={employeefieldData.gender.extra.optionList}
                            onSelect={(value) => updateValue(formController, employee[0]?.[0], 'gender', value)}
                            value={employeefieldData.gender.value}
                            showErrorMsg={employeefieldData.gender.error !== null}
                            errorMsg={employeefieldData.gender.error}
                        />
                    </div>
                </div>
                <hr className='w-100 border-secondary-opacity-50 my-2 d-xl-none d-none d-lg-inline' />

                <div className='family-member-other-details-section justify-content-between justify-content-xl-start'>
                    {/* gender in mobile veiw */}
                    <div className='other-details-section-gender mt-3 mt-xl-0 pr-xl-2 d-lg-none '>
                        <div className='d-flex d-xl-none align-items-center  mb-1'>
                            <img src={GenderIcon} alt='calender-icon' className='add-family-member-card-top-img' />
                            <p className='font-size-14 font-size-md-12 font-weight-light text-description-text-color ml-1 mb-0 ml-md-3'>
                                {employeefieldData.gender.label}

                            </p>
                        </div>

                        <BottomsheetDropdown
                            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light gender-dropdown'
                            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                            menuItemStyle='d-flex justify-content-between align-items-center'
                            selectedLabelKey='label'
                            bottomsheetTitle={employeefieldData.gender.extra.bottomSheetTitle}
                            defaultLabel='Select'
                            disabled={true}
                            menuList={employeefieldData.gender.extra.optionList}
                            onSelect={(value) => updateValue(formController, employee[0]?.[0], 'gender', value)}
                            value={employeefieldData.gender.value}
                            showErrorMsg={employeefieldData.gender.error !== null}
                            errorMsg={employeefieldData.gender.error}
                        />
                    </div>

                    <div
                        className={
                            `${employeefieldData.gender.error !== null
                                ? "mt-3 mt-xl-0 other-details-section-dob pr-xl-2"
                                : "mt-3 mt-xl-0 other-details-section-dob pr-xl-2"
                            }`}
                    >
                        <div className='d-flex align-items-center d-xl-none mb-1 mb-lg-2'>
                            <img src={DOBIcon} alt='calender-icon' className='add-family-member-card-top-img' />
                            <p className='font-size-14 font-size-md-12 font-weight-light text-description-text-color ml-1 mb-0 ml-md-3 text-nowrap'>
                                Date of Incorporation

                            </p>
                        </div>
                        <DatepickerModal
                            minDate={employeefieldData.dob.extra.minDate}
                            maxDate={employeefieldData.dob.extra.maxDate}
                            value={employeefieldData.dob.value}
                            date={employeefieldData.dob.value}
                            onChange={(value) => updateValue(formController, employee[0]?.[0], 'dob', value)}
                            showErrorMsg={employeefieldData.dob.error !== null}
                            textStyle='font-size-lg-12 font-size-14 font-weight-light'
                            errorMsg={employeefieldData.dob.error}
                            memberType={employee[0]?.[1].value.family_member_type}
                        />
                    </div>

                    {/* nationality in table & desktop view */}
                    <div className='mt-3 mt-xl-0 other-details-section-nationality pr-xl-2 d-none d-lg-block ' >
                        <div className='d-flex d-xl-none align-items-center  mb-1'>
                            <img src={NationalityIcon} alt='income-icon' className='add-family-member-card-top-img' />
                            <p className='font-size-14 font-size-md-12 font-weight-normal text-description-text-color ml-1 mb-0 ml-md-3'>
                                {"nationality"}
                            </p>
                        </div>

                        <BottomsheetDropdown
                            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
                            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                            menuItemStyle='d-flex justify-content-between align-items-center'
                            selectedLabelKey='label'
                            bottomsheetTitle={employeefieldData.nationality.extra.bottomSheetTitle}
                            defaultLabel={employeefieldData.nationality.label}
                            menuList={employeefieldData.nationality.extra.optionList}
                            value={employeefieldData.nationality.value}
                            onSelect={(value) => updateValue(formController, employee[0]?.[0], 'nationality', value)}
                            showErrorMsg={employeefieldData.nationality.error != null}
                            disabled={false}
                        />
                    </div>
                </div>
            </div>
        </div>
    );

}
export default observer(AddProposerData);